import { makeStyles } from "@material-ui/core";
import {
	DEFAULT_BOX_SHADOW,
	PRIMARY_BACKGROUND,
	instanceVclaim,
} from "App/constants";
import { today } from "App/utils/helpers";

export const urlGetBpjs = "/api/v1/emr/bridging/peserta/no-kartu-bpjs";

export const STYLE_WS_BRIDGING_BPJS = makeStyles({
	root: {
		width: "auto",
	},
	paper: {
		width: "100%",
		margin: "0",
		padding: "1rem 1.5rem",
		backgroundColor: PRIMARY_BACKGROUND,
		boxShadow: DEFAULT_BOX_SHADOW,
	},
	table: {
		width: "100%",
		margin: "0 auto",
		overflow: "auto",
	},
});

export const RESET_STATE_BPJS = {
	nomor_kartu: "",
	tgl_pelayanan: today(),
};

export const headCells = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "nik",
		disablePadding: true,
		label: "NIK",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "nama",
		disablePadding: true,
		label: "NAMA PASIEN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "noKartu",
		disablePadding: true,
		label: "NO. KARTU",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "umur",
		disablePadding: true,
		label: "UMUR",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "keterangan",
		disablePadding: true,
		label: "KELAS",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "keterangan",
		disablePadding: true,
		label: "STATUS",
		align: "center",
		minWidth: "100px",
	},
];

// Dipake buat di Rajal Get NIK pake Nomor Kartu
export const getBpjs = async (nomor_kartu, tgl_pelayanan) => {
	try {
		const api = await instanceVclaim.post(urlGetBpjs, {
			nomor_kartu,
			tgl_pelayanan,
		});

		const res = api.data;

		return {
			state: true,
			message: res.message,
			data: res?.response?.peserta,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};
